const KNOWN_EXTENSIONS = new Set([
  "pdf", "png", "jpg", "jpeg", "gif", "bmp", "tif", "tiff", "webp",
  "doc", "docx", "xls", "xlsx", "ppt", "pptx", "rtf", "txt", "csv",
  "zip", "rar", "7z", "xml", "html", "htm", "json"
]);

/** Возвращает расширение только если это известный тип файла (не часть имени вроде v2 или final). */
export function getKnownFileExtension(filename) {
  if (filename == null || filename === "") return null;
  const name = String(filename).trim();
  const dotIdx = name.lastIndexOf(".");
  if (dotIdx <= 0 || dotIdx >= name.length - 1) return null;
  const ext = name.substring(dotIdx + 1).toLowerCase();
  return KNOWN_EXTENSIONS.has(ext) ? ext.toUpperCase() : null;
}
